module.exports = __webpack_public_path__ + "img/c01.0d8b9852.png";